module.exports = __webpack_public_path__ + "static/img/jiankong.7673aae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/jiankong.png
// module id = yhYY
// module chunks = 1